import { render } from "./AddLessonUnitForBatch.vue?vue&type=template&id=b1284e58&scoped=true"
import script from "./AddLessonUnitForBatch.vue?vue&type=script&lang=js"
export * from "./AddLessonUnitForBatch.vue?vue&type=script&lang=js"

import "./AddLessonUnitForBatch.vue?vue&type=style&index=0&id=b1284e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1284e58"]])

export default __exports__